import {ISchiltzFacebookService} from "../../domain/facebook/ISchiltzFacebookService";
import {FacebookService, UIParams, UIResponse} from "ngx-facebook";
import {environment} from "../../../environments/environment";

export class SchiltzFacebookService implements ISchiltzFacebookService{

    private facebookService:FacebookService;

    constructor(facebookService: FacebookService) {
        this.facebookService = facebookService;
        this.facebookService.init({
            appId: environment.facebookAppId,
            version: 'v3.0'
        }).catch(err => {
            console.log("Cannot initialized Facebook service");
        });
    }

    public Share(link: string): Promise<void> {
        const options: UIParams = {
            method: 'share',
            href: link
        };

        return this.facebookService.ui(options).then((res: UIResponse) => {
            return Promise.resolve();
        });
    }

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/facebook/SchiltzFacebookService.ts